

import { IFieldAccessType } from '../../../../../component/admin-module/module/users/interface/field';
import ValidateField from '../../../validation';
import { IValidationError } from '../../../validation/type/validation-type';
import { FieldElement } from '../../field-element';
import { TValidationType, PropType } from '../field-properties.handler';

interface IStringProps {
  value: string;
  error?: IValidationError[];
  fieldType?: 'string';
}
export class StringProps extends PropType<IStringProps, IStringProps> {

  processValueFromRef(props: IStringProps): IStringProps {
    props.value = props.value || '';
    return props;
  }

  processValueToRef(newProps: IStringProps): IStringProps {
    newProps.value = newProps.value || '';
    return newProps;
  }

  processValidation(data: IStringProps | null, field: FieldElement, validationType: TValidationType): IValidationError[] {
    const value = data?.value || '';
    const validateField = new ValidateField();
    const validate = validateField.singleField(field, value || '', validationType);
    return field.accessType === IFieldAccessType.Required || !!value ? validate : [];
  }
}